"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePropertyUseSummaryWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordionPlugin_1 = require("../../../components/FalconAccordionPlugin");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var Detail = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail" }, children);
};
var DetailKey = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-key" }, children);
};
var DetailValue = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-value" }, children);
};
var AnnualHomePropertyUseSummaryWidget = exports.AnnualHomePropertyUseSummaryWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePropertyUseSummaryWidget, _super);
    function AnnualHomePropertyUseSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditPropertyUsePage = function () {
            _this.props.engine.setJourneyState({
                idToScrollTo: "propertyUseWidgetId"
            });
            _this.props.engine.navigate("yourDetails", false);
        };
        _this.fetchLookupValues = function () {
            var languageCode = "en-UK";
            var valuesToPopulate = [
                {
                    classifier: "residencyUsage",
                    field: _this.realEstate.residentsType,
                    stateName: "residencyUsage"
                },
                {
                    classifier: "propertyOccupancyType",
                    field: _this.realEstate.occupancyType,
                    stateName: "propertyOccupancy"
                },
                {
                    classifier: "propertyOwnershipType",
                    field: _this.realEstate.ownershipType,
                    stateName: "propertyOwnership"
                },
                {
                    classifier: "yearsLivedAtProperty",
                    field: _this.policyHolder.yearsAtProperty,
                    stateName: "yearsLivedAtProperty"
                }
            ];
            valuesToPopulate.forEach(function (item) {
                var lookupFieldValue = item.field == null ? undefined : item.field;
                _this.lookupService.fetchLookupValues(item.classifier, languageCode, lookupFieldValue).subscribe(function (lookupValues) {
                    var _a;
                    var fetchedLookupItem = lookupValues.find(function (lookupValue) { return lookupValue.id === item.field; });
                    if (fetchedLookupItem) {
                        _this.setState((_a = {}, _a[item.stateName] = fetchedLookupItem.value, _a));
                    }
                });
            });
        };
        _this.realEstate = _this.props.interaction.realEstate[0];
        _this.policyHolder = _this.props.interaction.policyHolder;
        _this.state = {
            residencyUsage: "",
            propertyOccupancy: "",
            propertyOwnership: "",
            yearsLivedAtProperty: "",
        };
        return _this;
    }
    AnnualHomePropertyUseSummaryWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues();
    };
    AnnualHomePropertyUseSummaryWidget.prototype.render = function () {
        return (React.createElement("div", { id: "propertyUseWidgetId", className: "collapsible-question-panel quote-details-widget" },
            React.createElement(FalconAccordionPlugin_1.FalconAccordion, { togglePositionTop: true, isShownClassName: "shown", toggleShown: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Property use"),
                    React.createElement("span", { className: "toggle-icon collapse-icon" })), toggleHidden: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center pt-0" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Property use"),
                    React.createElement("span", { className: "toggle-icon expand-icon" })) }, this.renderPropertyUseDetails())));
    };
    AnnualHomePropertyUseSummaryWidget.prototype.renderPropertyUseDetails = function () {
        return (React.createElement("div", { className: "accordion-content grid-make-2-col" },
            React.createElement("img", { className: "home-tick-image mb-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/home-icon-tick.png"), alt: "Home icon with the tick" }),
            React.createElement("div", { className: "section border-0 p-0" },
                React.createElement("div", { className: "section-contents mb-5" },
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Main home:"),
                        React.createElement(DetailValue, null, this.realEstate.isMainHome ? "Yes" : "No")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Business use:"),
                        React.createElement(DetailValue, null, this.realEstate.businessUse !== "NOT_USED" ? "Yes" : "No")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "People living at the property:"),
                        React.createElement(DetailValue, null, this.state.residencyUsage)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Number of adults:"),
                        React.createElement(DetailValue, null, this.realEstate.adultFamilyMemberCount)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Children under 18 years old:"),
                        React.createElement(DetailValue, null, this.realEstate.numberOfChildren !== 0 ? "Yes" : "No")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Occupied property:"),
                        React.createElement(DetailValue, null, this.state.propertyOccupancy)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Rent or own:"),
                        React.createElement(DetailValue, null, this.state.propertyOwnership)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Years lived at the property:"),
                        React.createElement(DetailValue, null, this.state.yearsLivedAtProperty)))),
            React.createElement("button", { type: "button", className: "btn btn-primary btn-add btn-summary-chapter grid-col-2", onClick: this.navigateToEditPropertyUsePage }, "Edit property use")));
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomePropertyUseSummaryWidget.prototype, "lookupService", void 0);
    return AnnualHomePropertyUseSummaryWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomePropertyUseSummaryWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomePropertyUseSummaryWidget.js
// module id = 3682
// module chunks = 0